import React, { useState } from 'react';
import TextField from '../../Form/TextField';
import FormGroupDescription from '../../formGroupDescription';
import ButtonGroup from '../../Form/ButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import {
    EuiFlyout,
    EuiFlyoutBody,
    EuiFlyoutHeader,
    EuiSpacer,
    EuiText,
    EuiTitle,
    EuiButton,
    EuiFlexItem,
} from '@elastic/eui';
import { useFormContext } from 'react-hook-form';
import { requestForRiderService } from '../../../api/requestThirdPartyRiderService';
import { getOutletDetails } from '../../../api/outlet/getOutletDetails';

const ShadowFaxRiders = () => {
    const {
        formState: { errors },
        control,
        watch,
        setValue,
    } = useFormContext();
    const outletId = useSelector((state) => state.outlet.selectedOutletId);
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);
    const dispatch = useDispatch();
    const outlet = useSelector((state) => state.outlet.selectedOutletDetails);
    const approvalDate = outlet?.third_party_rider_setting?.shadowfax_request?.approval_date;
    const serviceStatus = outlet?.third_party_rider_setting?.shadowfax_request?.status;

    const startService = () => {
        dispatch(requestForRiderService('shadowfax', 'rider service request for Shadowfax')).then((res) => {
            dispatch(getOutletDetails(outletId));
        });
    };

    let flyout;
    if (isFlyoutVisible) {
        console.log(`is_shadowfax_integration_enabled ==>`, watch('is_shadowfax_integration_enabled'));
        flyout = (
            <EuiFlyout
                ownFocus
                onClose={() => {
                    setIsFlyoutVisible(!isFlyoutVisible);
                }}
                aria-labelledby={'simpleFlyoutTitle'}
            >
                <EuiFlyoutHeader hasBorder>
                    <EuiTitle size='m'>
                        <h2>Shadowfax riders</h2>
                    </EuiTitle>
                </EuiFlyoutHeader>
                <EuiFlyoutBody>
                    <ButtonGroup
                        idSelected={watch('is_shadowfax_integration_enabled') ? '1' : '0'}
                        color='primary'
                        control={control}
                        setValue={setValue}
                        name='is_shadowfax_integration_enabled'
                        watch={watch}
                        label={'Shadowfax integration'}
                    />

                    {/* {watch('is_shadowfax_integration_enabled') ? (
                        <>
                            <TextField
                                errors={errors}
                                label='ShadowFax token'
                                name='shadowfax_token'
                                placeholder='Enter ShadowFax token'
                                rules={{ required: 'Please Enter DShadowFax token' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='ShadowFax client code'
                                name='shadowfax_client_code'
                                placeholder='Enter ShadowFax client code'
                                rules={{ required: 'Please enter ShadowFax client code' }}
                                control={control}
                            />
                        </>
                    ) : (
                        ''
                    )} */}
                </EuiFlyoutBody>
            </EuiFlyout>
        );
    }

    return (
        <div style={{ maxWidth: '650px' }}>
            <FormGroupDescription
                title={restaurantDescriptions?.shadowfax_riders?.display_name}
                description={restaurantDescriptions?.shadowfax_riders?.description}
            >
                <EuiFlexItem>
                    <EuiButton
                        style={{
                            backgroundColor: serviceStatus === 'approved' && '#228B22',
                            color: serviceStatus === 'approved' && 'white',
                        }}
                        fill
                        onClick={startService}
                        disabled={serviceStatus ? true : false}
                    >
                        {serviceStatus ? serviceStatus : 'START SERVICE'}
                    </EuiButton>
                </EuiFlexItem>
                <EuiSpacer style={{ marginTop: '6px' }}>
                    <EuiText textAlign='center' size='xs'>
                        ------ OR ------
                    </EuiText>
                </EuiSpacer>
                <EuiFlexItem>
                    <EuiButton onClick={() => setIsFlyoutVisible(!isFlyoutVisible)}>CONNECT ACCOUNT</EuiButton>
                </EuiFlexItem>
                {flyout}
            </FormGroupDescription>
            {serviceStatus === 'pending' && (
                <EuiText
                    style={{
                        padding: '8px 12px',
                        background: '#BBB',
                        color: 'white',
                        marginBottom: '12px',
                        borderRadius: '4px',
                        // width: '65%',
                    }}
                >
                    <p> Your reqeust has been received and it shall be activated by {approvalDate} </p>
                </EuiText>
            )}
        </div>
    );
};

export default ShadowFaxRiders;
